import styled from "styled-components";
export const SubStepLink = styled.a `
  font-size: 14px;
  grid-column: 2;
  grid-row: 1;
  margin: 8px 32px;
  opacity: ${(props) => (props.completed ? "0.6" : "1")};
  text-align: left;
  text-decoration: ${(props) => (props.active ? "underline" : "none")};
  white-space: nowrap;
`;
export const SubStepListItem = styled.li `
  display: grid;
  grid-template-columns: 34px auto;
`;
//# sourceMappingURL=styled.js.map